export default (state, action) => {
  if (typeof action.payload.aggregations === "undefined") {
    return Object.assign({}, state, {
      data: {
        ...state.data,
        items: [...action.payload.items],
        loading: false,
        empty: action.payload.items.length === 0 ? true : false,
      },
    });
  }
  return Object.assign({}, state, {
    data: {
      ...state.data,
      ...action.payload,
      aggregations: [...action.payload.aggregations],
      loading: false,
      empty: action.payload.items.length === 0 ? true : false,
    },
  });
};
